import { AtLeast } from '../../helpers'
import { Block, BlockType } from '../block'

export const nonStructuralParentTypes = [
  'instance',
  'list',
  'rich-text',
  'reference',
] satisfies BlockType[]

export const isStructuralBr = ({
  block,
  parent,
}: {
  block: AtLeast<Block, 'type'>
  parent: AtLeast<Block, 'type'>
}) => {
  if (block.type === 'component') return true
  return !nonStructuralParentTypes.includes(parent.type)
}
